import _ from 'lodash';

import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import './Steps.css';
import { Payment } from './payment';
import Modal from 'components/common/modal/Modal';
import SelectAccount from './selectAccount/SelectAccount';
import {init, setStep} from 'redux/actions/steps';


class Steps extends Component {
  constructor(props) {
    super(props);

    const state = props.location.state || {};
    const params = new URLSearchParams(state.prevSearch);

    if (!props.steps.isRequest) {
      props.dispatch(init());
    }

    this.state = {
      error: params.get('error')
    };

    _.bindAll(this, ['handleChangeTab', 'handleOpenModal', 'paymentMethodConfirmed']);
  }


  componentDidMount() {
    if (this.state.response && this.state.response.msg) {
      this.handleOpenModal(this.state.response.msg);
    }
  }


  handleChangeTab(step) {
    this.props.dispatch(setStep(step));
    window.scrollTo(0, 0);
  }


  handleOpenModal(msg) {
    this._modal.setContent(React.createElement("div", {dangerouslySetInnerHTML: {__html: msg}}));
    this._modal.openModal();
  }


  paymentMethodConfirmed() {
    return this.props.dispatch(init());
  }


  render() {
    if (!this.props.steps.isGet) return (<span/>);
    return (
      <div className="c-steps gradient full-screen">
          <Tabs
            className='container'
            selectedIndex={this.props.steps.step}
            selectedTabClassName='active'
            disabledTabClassName='disabled'
            onSelect={tabIndex => this.props.dispatch(setStep(tabIndex))}
          >
            <TabList>
              <Tab>1. Customer data</Tab>
              <Tab disabled={this.props.steps.state.crms.length === 0} >2. Payment</Tab>
            </TabList>

            <TabPanel>
              <SelectAccount
                step={this.props.steps.step}
                state={this.props.steps.state}
                handleOpenModal={this.handleOpenModal}
                handleChangeTab={this.handleChangeTab}
              />
            </TabPanel>

            <TabPanel>
              <Payment
                methodConfirmed={this.paymentMethodConfirmed}
                dispatch={this.props.dispatch}
              />
            </TabPanel>

            <Modal
              className='c-steps__modal'
              ref={(modal) => { this._modal = modal; }}
              title={(<h2>Unexpected error while communicating with the OAuth server</h2>)}
            />
          </Tabs>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {steps: state.steps};
}

export default connect(mapStateToProps)(Steps);



// WEBPACK FOOTER //
// ./src/components/core/steps/Steps.jsx